import React from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Button} from '../../components/Interface/Forms/Buttons/Button';
import {Header} from '../../components/Interface/Headers/Header';
import {Titles} from '../../components/Interface/Typographies/Titles';
import {useAuth} from '../../context/auth';

import {Container, Content, Footer} from './styles';

export function ChangePassword() {
  const {setShowSign, setForgotPasswordFromChangePassword} = useAuth();

  function handleTrocarSenha() {
    setForgotPasswordFromChangePassword(true);
    setShowSign(true);
  }

  return (
    <Container>
      <Header icon="chevron-left" />
      <Content>
        <Titles
          title="Para continuar, troque sua senha."
          subtitle="Por questões de segurança, será necessário alterar sua senha para continuar utilizando essa forma de pagamento."
        />
      </Content>
      <Footer>
        <SafeAreaView>
          <Button
            title="Trocar minha senha"
            enabled
            onPress={handleTrocarSenha}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
